<template lang="pug">
    table.keen-eye-table(
        :class="{\
            'keen-eye-table--small-border': colors.length > 6,\
        }"
    )
        tbody(v-if="colors.length")
            tr.keen-eye-table__row(
                v-for='(row, rowIndex) in colors',
                :key='rowIndex'
            )
                td.keen-eye-table__cell(
                    v-for='(column, columnIndex) in row',
                    :key='columnIndex'
                    :style="itemStyle"
                )
                    .keen-eye-table__cell_preview(v-if="isShown" :style='{backgroundColor: `${column}`}')
                    .keen-eye-table__press-item(v-if="!isShown" @click='handleClick(column, rowIndex, columnIndex)')

</template>

<script>
    export default {
        props: {
            colors: {
                type: Array,
                default: null,
            },
            isShown: {
                type: Boolean,
                default: false,
            },
            displaySpeed: {
                type: Number,
                default: 0,
            },
        },
        mounted() {
            window.addEventListener('resize', this.calculateSizeForMemorizeTable);
            this.calculateSizeForMemorizeTable();
        },
        data() {
            return {
                itemSize: 0,
                itemLineHeight: 73,
            };
        },
        computed: {
            itemStyle() {
                return {
                    height: this.itemSize + 'px',
                    width: this.itemSize + 'px',
                    'font-size': (this.itemLineHeight - 9) * this.fontCoefficient + 'px',
                    'line-height': this.itemLineHeight * this.fontCoefficient + 'px',
                };
            },
            fontCoefficient() {
                return this.itemSize / this.itemLineHeight;
            },
        },
        methods: {
            handleClick(color, rowIndex, columnIndex) {
                if (this.isShown) {
                    return;
                }
                let selectedCell = event.target;
                this.$emit('handleClick', { selectedCell, color, rowIndex, columnIndex });
            },
            calculateSizeForMemorizeTable() {
                this.itemSize = 0;
                this.$nextTick(() => {
                    let keenEyeTable = document.querySelector('.keen-eye-table');
                    let items = Array.from(document.querySelectorAll('.keen-eye-table__cell'));
                    const isSafari =
                        /constructor/i.test(window.HTMLElement) ||
                        (function(p) {
                            return p.toString() === '[object SafariRemoteNotification]';
                        })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
                    const newDimensionValue = value => (isSafari ? value * 0.88 : value);

                    const rowsAmount = this.colors.length;
                    const columnsAmount = this.colors[0].length;
                    const heightCoefficient = rowsAmount / Math.max(rowsAmount, columnsAmount);
                    const widthCoefficient = columnsAmount / Math.max(rowsAmount, columnsAmount);

                    let tempTableSize;
                    if (isSafari) {
                        const playBoxContainer = document.querySelector('.play-box');
                        tempTableSize = Math.min(
                            playBoxContainer.clientWidth / widthCoefficient,
                            playBoxContainer.clientHeight / heightCoefficient
                        );
                    } else {
                        tempTableSize = Math.min(keenEyeTable.clientWidth, keenEyeTable.clientHeight);
                    }
                    keenEyeTable.style.height = newDimensionValue(tempTableSize) * heightCoefficient + 'px';
                    keenEyeTable.style.width = newDimensionValue(tempTableSize) * widthCoefficient + 'px';
                    this.itemSize = newDimensionValue(items[0].clientWidth);
                });
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.calculateSizeForMemorizeTable);
        },
    };
</script>

<style scoped lang="scss">
    .keen-eye-table {
        width: 90%;
        height: 90%;
        margin: 0 auto;
        table-layout: fixed;
        border-spacing: 0;
    }

    .keen-eye-table--disabled .keen-eye-table__press-item {
        pointer-events: none;
        cursor: auto;
        &:hover {
            background-color: transparent;
        }
    }

    .keen-eye-table__cell {
        text-align: center;
        vertical-align: middle;
        background: $hsl-color-gray-92;
        font-size: 62px;
        line-height: 73px;
    }

    .keen-eye-table__cell_preview {
        width: 80%;
        height: 80%;
        @include media($lg) {
            width: 90%;
            height: 90%;
        }
        font-size: 62px;
        margin: auto;
        display: flex;
        user-select: none;
        align-items: center;
        border-radius: $border-radius-12;
        justify-content: center;
        color: $hsl-color-green-58;
        background-color: $x-color-white;
    }
    .keen-eye-table__press-item {
        width: 80%;
        height: 80%;
        @include media($lg) {
            width: 90%;
            height: 90%;
        }
        font-size: 62px;
        margin: auto;
        display: flex;
        cursor: pointer;
        user-select: none;
        align-items: center;
        border-radius: $border-radius-12;
        box-shadow: 0 0 2px $hsl-color-gray-74;
        background-color: $x-color-white;
        justify-content: center;
        color: $hsl-color-green-58;
        transition: background-color 0.1s;
        &:hover {
            background-color: rgba($hsl-color-green-58, 0.3);
        }
    }

    .keen-eye-table__press-item_green {
        color: $x-color-white;
        background-color: $hsl-color-green-58;
        &:hover {
            background-color: $hsl-color-green-58;
        }
    }

    .keen-eye-table__press-item_white {
        transition: none;
        background-color: $hsl-color-gray-97;
        &:hover {
            background-color: $hsl-color-gray-97;
        }
    }
    @import '@/assets/sass/animations/shake.scss';
</style>
